import { useGetAllUsersQuery } from '../store/user/user'
import { useGetInvitesQuery } from '../store/auth/auth'
import { getInviteRoleGroups } from '../views/ManageTeam/InviteRoleGroups'
import { RoleType } from '../models/Role'
import { useAppSelector } from '../store/hooks'
import { selectAccountId } from '../store/auth/authSlice'
import { defaultPendingInvitationsFilter } from '../views/ManageTeam/PendingInvitations/utils'

export const useUsedSeats = () => {
  const accountId = useAppSelector(selectAccountId)
  const { data: users } = useGetAllUsersQuery({ accountId, identityTypes: ['idp'] })
  const { data: invites } = useGetInvitesQuery({ accountId: accountId, pageRequest: { page: 0, size: 500 }, filter: defaultPendingInvitationsFilter })
  const seatRoles = [
    ...new Set(
      getInviteRoleGroups()
        .filter((r) => r.type === RoleType.SEAT)
        .flatMap((r) => r.roleIds),
    ),
  ]
  const usedInviteSeats =
    invites?.data
      .filter((i) => i.state === 'pending')
      .map((i) => i.user.roleIds)
      .filter((ur) => ur.some((r) => seatRoles.includes(r))).length ?? 0
  const teamSeats = users?.data.map((u) => u.roles.map((r) => r.id)).filter((ur) => ur.some((r) => seatRoles.includes(r))).length ?? 1
  const usedSeats = teamSeats + usedInviteSeats

  return usedSeats
}
